import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateEU, formatTime24Hour, formatTimeSpanNormal} from './useTimeFormatters.helpers';

function toDate(date: string | Date): Date {
  return typeof date === 'string' ? new Date(date) : date;
}

interface HookReturnType {
  formatDate(timestamp: string | Date): string;
  formatTime(timestamp: string | Date): string;
  formatDateTime(timestamp: string | Date): string;
  formatTimeSpan(seconds: number): string;
}

function useTimeFormatters(): HookReturnType {
  const { t } = useTranslation();

  const formatDate = useCallback<HookReturnType['formatDate']>(
    (date) => {
      const actualDate = toDate(date);
          return formatDateEU(actualDate);
    },
    []
  );

  const formatTime = useCallback<HookReturnType['formatTime']>(
    (date) => {
      const actualDate = toDate(date);
          return formatTime24Hour(actualDate, true);
    },
    [],
  );

  const formatDateTime = useCallback<HookReturnType['formatDateTime']>(
    (date) => `${formatDate(date)} ${formatTime(date)}`,
    [formatDate, formatTime],
  );

  const formatTimeSpan = useCallback<HookReturnType['formatTimeSpan']>(
    (seconds) => {
          return formatTimeSpanNormal(t, seconds);
      },
    [t],
  );

  const value = useMemo(
    () => ({
      formatDate,
      formatTime,
      formatDateTime,
      formatTimeSpan,
    }),
    [formatDate, formatDateTime, formatTime, formatTimeSpan],
  );

  return value;
}

export default useTimeFormatters;